import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import { maxWidth, retina } from '../../../Utils/utilsStyle';

type Props = {
  logo: string,
  width?: string,
  height?: string,
  widthSm?: string,
  heightSm?: string,
  onClick?: () => void
} & typeof defaultProps;

const defaultProps = {
  width: '210px',
  height: '160px',
  widthSm: '110px',
  heightSm: '65px',
  onClick: () => { },
};

const Wrapper = styled.div < { color: string, width: string, height: string, widthSm: string, heightSm: string, }>`
 width: ${(props) => props.width};
 height: ${(props) => props.height};
 border-radius: 13px;
 padding: 5px;
 background:conic-gradient(from -70deg, ${(props) => props.color});
 background-color: ${(props) => props.color};
 position:relative;
 margin: 0px 0px 15px 0px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    width: ${(props) => props.widthSm};
    height: ${(props) => props.heightSm};
    border-radius: 11px;
    padding: 3px;
  }
  .lazy-load-image-background {
    height: 100%;
    width: 100%;
  }
  img {
    height: 100%;
    width: 100%;
    border-radius: 8px;
  }
  .progress-wrapper{
    padding: 0px 10px;
    position: absolute;
    bottom: 15px;
    width: 95%;
    div {
      height:4px;
    }
  }
`;

const BannerWidget = function BannerWidget(props: Props) {
  const {
    logo,
    width,
    height,
    widthSm,
    heightSm,
    onClick,
  } = props;

  return (
    <Wrapper
      color="#D8D3C8"
      width={width}
      height={height}
      widthSm={widthSm}
      heightSm={heightSm}
      className="export-widget-industries"
    >
      <LazyLoadImage
        src={logo}
        className="img-fluid"
        alt="article-hold-banner"
        effect="blur"
        onClick={onClick}
      />
    </Wrapper>
  );
};

BannerWidget.defaultProps = defaultProps;
export default BannerWidget;
